/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryEntryResponse } from './RevisdomAPIViewModelsEntryEntryResponse';
import {
    RevisdomAPIViewModelsEntryEntryResponseFromJSON,
    RevisdomAPIViewModelsEntryEntryResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryEntryResponseToJSON,
    RevisdomAPIViewModelsEntryEntryResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryEntryResponse';
import type { RevisdomAPIViewModelsUserResponse } from './RevisdomAPIViewModelsUserResponse';
import {
    RevisdomAPIViewModelsUserResponseFromJSON,
    RevisdomAPIViewModelsUserResponseFromJSONTyped,
    RevisdomAPIViewModelsUserResponseToJSON,
    RevisdomAPIViewModelsUserResponseToJSONTyped,
} from './RevisdomAPIViewModelsUserResponse';

/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryEntryDetailResponse
 */
export interface RevisdomAPIViewModelsEntryEntryDetailResponse {
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsEntryEntryResponse>}
     * @memberof RevisdomAPIViewModelsEntryEntryDetailResponse
     */
    children?: Array<RevisdomAPIViewModelsEntryEntryResponse> | null;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryEntryDetailResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryEntryDetailResponse
     */
    projectId?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryEntryDetailResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryEntryDetailResponse
     */
    path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryEntryDetailResponse
     */
    status?: RevisdomAPIViewModelsEntryEntryDetailResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryEntryDetailResponse
     */
    entryType?: RevisdomAPIViewModelsEntryEntryDetailResponseEntryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryEntryDetailResponse
     */
    thumbnailUrl?: string | null;
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsUserResponse>}
     * @memberof RevisdomAPIViewModelsEntryEntryDetailResponse
     */
    share?: Array<RevisdomAPIViewModelsUserResponse> | null;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsEntryEntryDetailResponse
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsEntryEntryDetailResponse
     */
    updatedAt?: Date | null;
}


/**
 * @export
 */
export const RevisdomAPIViewModelsEntryEntryDetailResponseStatusEnum = {
    NeedsReview: 'NeedsReview',
    Updated: 'Updated',
    Approved: 'Approved'
} as const;
export type RevisdomAPIViewModelsEntryEntryDetailResponseStatusEnum = typeof RevisdomAPIViewModelsEntryEntryDetailResponseStatusEnum[keyof typeof RevisdomAPIViewModelsEntryEntryDetailResponseStatusEnum];

/**
 * @export
 */
export const RevisdomAPIViewModelsEntryEntryDetailResponseEntryTypeEnum = {
    Project: 'Project',
    Folder: 'Folder',
    File: 'File',
    Version: 'Version'
} as const;
export type RevisdomAPIViewModelsEntryEntryDetailResponseEntryTypeEnum = typeof RevisdomAPIViewModelsEntryEntryDetailResponseEntryTypeEnum[keyof typeof RevisdomAPIViewModelsEntryEntryDetailResponseEntryTypeEnum];


/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryEntryDetailResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryEntryDetailResponse(value: object): value is RevisdomAPIViewModelsEntryEntryDetailResponse {
    return true;
}

export function RevisdomAPIViewModelsEntryEntryDetailResponseFromJSON(json: any): RevisdomAPIViewModelsEntryEntryDetailResponse {
    return RevisdomAPIViewModelsEntryEntryDetailResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryEntryDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryEntryDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(RevisdomAPIViewModelsEntryEntryResponseFromJSON)),
        'id': json['id'] == null ? undefined : json['id'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'name': json['name'] == null ? undefined : json['name'],
        'path': json['path'] == null ? undefined : json['path'],
        'status': json['status'] == null ? undefined : json['status'],
        'entryType': json['entryType'] == null ? undefined : json['entryType'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'share': json['share'] == null ? undefined : ((json['share'] as Array<any>).map(RevisdomAPIViewModelsUserResponseFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function RevisdomAPIViewModelsEntryEntryDetailResponseToJSON(json: any): RevisdomAPIViewModelsEntryEntryDetailResponse {
    return RevisdomAPIViewModelsEntryEntryDetailResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryEntryDetailResponseToJSONTyped(value?: RevisdomAPIViewModelsEntryEntryDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(RevisdomAPIViewModelsEntryEntryResponseToJSON)),
        'id': value['id'],
        'projectId': value['projectId'],
        'name': value['name'],
        'path': value['path'],
        'status': value['status'],
        'entryType': value['entryType'],
        'thumbnailUrl': value['thumbnailUrl'],
        'share': value['share'] == null ? undefined : ((value['share'] as Array<any>).map(RevisdomAPIViewModelsUserResponseToJSON)),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt'] as any).toISOString()),
    };
}

